import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { BfxHedgeOrderStagingRow } from "../../../shared/cubiq-services/model/benchmarks/BfxHedgeOrderStagingRow";

@Component({
  selector: ".strategy-params",
  template: `<div *ngIf="visible" class="bfx-cell-editable edit-algo-params">
    <i class="bfx-icon-sm icon-edit" (click)="showDialog()"></i>
    <span>{{ params.value }}</span>
  </div>`,
  standalone: false,
})
export class StrategyParametersRenderer implements ICellRendererAngularComp {
  public params: any;
  public visible: boolean = false;

  // called on init
  agInit(params: any): void {
    this.doVal(params);
  }

  doVal(params: any): void {
    this.params = params;
    this.visible = (params.data as BfxHedgeOrderStagingRow).bulkEditRow
      ? false
      : (params.data as BfxHedgeOrderStagingRow).orderRequest.orderType == CubiqTS.OrderType.BMALGO;
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.doVal(params);
    return true;
  }

  showDialog(): void {
    if (this.params.context && this.params.context.editStrategyParameters) {
      this.params.context.editStrategyParameters(this.params.data.id);
    }
  }
}
